import React, { Component } from 'react'
import { checkTranslation, translate } from '../../utils/useful'

import DataMenu from './DataMenu'
import ToolsMenu from './ToolsMenu'
import ViewsMenu from './ViewsMenu'


export default class BookingUserToolbar extends Component {

    state = {
        active: 'explore'
    }

    componentDidMount() {
        // console.log("componentDidMount !!!!!")
    }

    componentDidUpdate = (prevProps) => {

    }

    changeStage = (name) => {
        this.setState({ active: name })
        this.props.functionsHandler(null, 'changeStage', name)
    }

    render() {
        return (
            <div className='h-100  w-100  scroll-no-scrollbar flexc '>

                {/* <ViewsMenu colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} /> */}

                <div className='w-100 flexcb'>
                    <div className='flexc'>
                        <button className={"br-5 flexc px-2 py-2 dark-blur-hover"} onClick={() => { this.changeStage('explore') }} style={{ backgroundColor: this.state.active == 'explore' ? '#10101030' : null }}>
                            {/* <img className='mrd-2 flexcc' width={14} src={'/assets/icons/target.svg'} alt="" /> */}
                            <p className='font-size-14 ' style={{ color: '#fff', }}>{checkTranslation("Explore")}</p>
                        </button>

                        <button className={"br-5 flexc px-2 py-2 dark-blur-hover"} onClick={() => { this.changeStage('previous') }} style={{ backgroundColor: this.state.active == 'previous' ? '#10101030' : null }} >
                            <p className='font-size-14 ' style={{ color: '#fff', }}>{checkTranslation("Intractions")}</p>
                        </button>

                    </div>
                    <div className=' navbar-search2 py-1 px-2 br-30' style={{ width: '200px' }}>
                        <div className='d-flex flexcb'>
                            <input className="w-100 px-1" onChange={e => this.changeValue(e)} value={this.state.search} type="text" placeholder={translate(`Search in Commerce`)} style={{ backgroundColor: 'transparent', }} />
                            <img style={{ width: '25px', height: '25px' }} src="/images/icons/search.svg" />
                        </div>
                    </div>
                </div>


            </div>
        )
    }
}
